


















import Vue from "vue";
export default Vue.extend({
  methods: {
    goto(category) {
      this.$router.push("/members/maps/" + category);
      this.category = category;
      this.categoryTitle = this.categoryToTitle[category];
      this.getMarkers();
    },
  },
});
